const getters = {
  device: state => state.user.device,
  userlists: state => state.user.userlists,
  transitionName: state => state.user.transitionName,
  selfOrTeam: state => state.user.selfOrTeam,


}
export default getters
